export interface TransparenceLink {
  id: string;
  title: { ar: string; fr: string; zgh: string };
  desc: { ar: string; fr: string; zgh: string };
  url: string;
  iconName: string;
  imageUrl?: string;
  internal: boolean;
}

export const initialTransparenceLinks: TransparenceLink[] = [
  {
    id: "link-1",
    title: { ar: "صندوق الدعم لتشجيع تمثيلية النساء", fr: "Fonds d’appui pour la promotion de la représentativité des femmes", zgh: "ⴰⵙⵏⴷⵓⵇ ⵏ ⵡⴰⵏⴰⵍ ⵉ ⵜⵎⵙⴽⵜⵉⵜ ⵏ ⵜⵎⵖⴰⵔⵉⵏ" },
    desc: { ar: "آلية تهدف إلى تعزيز قدرات النساء وتيسير إدماجهن في الحياة السياسية والانتخابية الوطنية.", fr: "Mécanisme visant à renforcer les capacités des femmes afin de faciliter leur intégration politique.", zgh: "Mécanisme visant à renforcer les capacités des femmes afin de faciliter leur intégration politique." },
    url: "https://nissaemoucharaka.ma/",
    iconName: "Users",
    imageUrl: "/images/nissae-moucharaka.png",
    internal: false
  },
  {
    id: "link-2",
    title: { ar: "العرائض المواطنة", fr: "Pétitions citoyennes", zgh: "ⵜⵉⵣⵎⵎⴰⵔ ⵏ ⵓⵏⴰⵎⵓⵔ" },
    desc: { ar: "بادر أو وقع على عرائض لتقديم مطالبك للمؤسسات المنتخبة.", fr: "Initiez ou signez des pétitions pour porter vos revendications auprès des institutions élues.", zgh: "Initiez ou signez des pétitions pour porter vos revendications auprès des institutions élues." },
    url: "/actions/petitions",
    iconName: "FileSignature",
    internal: true
  },
  {
    id: "link-3",
    title: { ar: "الملتمسات", fr: "Doléances", zgh: "ⵉⵙⵓⵜⴰⵔ" },
    desc: { ar: "قدم ملتمساتك للمؤسسات المختصة للدفاع عن حقوقك.", fr: "Soumettez vos doléances aux institutions compétentes pour défendre vos droits.", zgh: "Soumettez vos doléances aux institutions compétentes pour défendre vos droits." },
    url: "/actions/doleances",
    iconName: "Inbox",
    internal: true
  },
  {
    id: "link-4",
    title: { ar: "الشكايات (Chikaya)", fr: "Réclamations (Chikaya)", zgh: "ⴰⵛⴽⴰ (Chikaya)" },
    desc: { ar: "بوابة الشكايات لتقديم وتتبع تظلماتكم.", fr: "Soumettre et suivre vos réclamations.", zgh: "Soumettre et suivre vos réclamations." },
    url: "https://www.chikaya.ma",
    iconName: "Megaphone",
    imageUrl: "/images/logos/chikaya.png",
    internal: false
  },
  {
    id: "link-5",
    title: { ar: "الحق في الحصول على المعلومات", fr: "Droit d'Accès à l'Information", zgh: "ⴰⵣⵔⴼ ⵏ ⵓⵎⵙⵍⴰⵢ ⵅⴼ ⵜⵏⵖⵎⵉⵙⵉⵏ" },
    desc: { ar: "بوابة الحصول على المعلومات", fr: "Portail d'accès à l'information publique.", zgh: "Portail d'accès à l'information publique." },
    url: "https://www.cdai.ma/",
    iconName: "FileText",
    imageUrl: "/images/logos/logo info acces.jpg",
    internal: false
  },
  {
    id: "link-6",
    title: { ar: "المشاركة المواطنة", fr: "Participation Citoyenne", zgh: "ⵜⴰⴷⵔⴰⵡⵜ ⵜⴰⵏⴰⵎⵓⵔⵜ" },
    desc: { ar: "البوابة الوطنية للمشاركة المواطنة", fr: "Portail national de la participation citoyenne.", zgh: "Portail national de la participation citoyenne." },
    url: "https://www.eparticipation.ma/",
    iconName: "Users",
    imageUrl: "/images/logos/eparticipation.jpg",
    internal: false
  },
  {
    id: "link-7",
    title: { ar: "المبادرة الوطنية للتنمية البشرية (INDH)", fr: "Initiative Nationale pour le Développement Humain (INDH)", zgh: "Initiative Nationale pour le Développement Humain (INDH)" },
    desc: { ar: "برامج التنمية البشرية والمبادرات المحلية", fr: "Programmes de développement humain.", zgh: "Programmes de développement humain." },
    url: "https://www.indh.ma/",
    iconName: "HandHeart",
    imageUrl: "/images/logos/indh.png",
    internal: false
  },
  {
    id: "link-8",
    title: { ar: "الخدمات الإدارية (إدارتي)", fr: "Services Administratifs (Idarati)", zgh: "Services Administratifs (Idarati)" },
    desc: { ar: "بوابة الخدمات الإدارية والقانونية", fr: "Portail des services administratifs.", zgh: "Portail des services administratifs." },
    url: "https://idarati.ma/",
    iconName: "Building2",
    imageUrl: "/images/logos/idarati.jpg",
    internal: false
  },
  {
    id: "link-9",
    title: { ar: "الحكومة المنفتحة (OPENGOV)", fr: "Gouvernement Ouvert (OPENGOV)", zgh: "Gouvernement Ouvert (OPENGOV)" },
    desc: { ar: "شراكة الحكومة المنفتحة بالمغرب", fr: "Partenariat pour le Gouvernement Ouvert.", zgh: "Partenariat pour le Gouvernement Ouvert." },
    url: "https://www.gouvernement-ouvert.ma/",
    iconName: "Globe",
    imageUrl: "/images/logos/opengov.png",
    internal: false
  },
  {
    id: "link-10",
    title: { ar: "مؤسسة وسيط المملكة", fr: "Médiation (Médiateur du Royaume)", zgh: "ⴰⵎⵙⴰⵙⴰ ⵏ ⵜⴳⵍⴷⵉⵜ" },
    desc: { ar: "مؤسسة الوسيط للدفاع عن الحقوق", fr: "Institution du Médiateur du Royaume.", zgh: "Institution du Médiateur du Royaume." },
    url: "https://www.mediateur.ma/",
    iconName: "Scale",
    imageUrl: "/images/logos/logo-mediateur.png",
    internal: false
  },
  {
    id: "link-11",
    title: { ar: "الميزانية المواطنة", fr: "Budget Citoyen", zgh: "Budget Citoyen" },
    desc: { ar: "فهم ميزانية الدولة بشكل مبسط", fr: "Comprendre le budget de l'État simplement.", zgh: "Comprendre le budget de l'État simplement." },
    url: "https://www.finances.gov.ma/fr/Pages/budget-citoyen.aspx",
    iconName: "PieChart",
    imageUrl: "/images/logos/budget.png",
    internal: false
  },
  {
    id: "link-12",
    title: { ar: "الميزانية المستجيبة للنوع الاجتماعي (BSG)", fr: "Budget Sensible au Genre (BSG)", zgh: "Budget Sensible au Genre (BSG)" },
    desc: { ar: "مركز الامتياز لميزانية النوع", fr: "Centre d'excellence pour la budgétisation.", zgh: "Centre d'excellence pour la budgétisation." },
    url: "https://cebsg.finances.gov.ma/",
    iconName: "HeartPulse",
    internal: false
  },
  {
    id: "link-13",
    title: { ar: "المجلس الوطني لحقوق الإنسان (CNDH)", fr: "Conseil National des Droits de l'Homme", zgh: "Conseil National des Droits de l'Homme" },
    desc: { ar: "حماية والنهوض بحقوق الإنسان", fr: "Protection et promotion des droits humains.", zgh: "Protection et promotion des droits humains." },
    url: "https://www.cndh.ma",
    iconName: "Shield",
    imageUrl: "/images/logos/cndh.png",
    internal: false
  },
  {
    id: "link-14",
    title: { ar: "المجلس الأعلى للحسابات", fr: "Cour des Comptes", zgh: "Cour des Comptes" },
    desc: { ar: "الرقابة العليا على المالية العامة", fr: "Contrôle supérieur des finances publiques.", zgh: "Contrôle supérieur des finances publiques." },
    url: "https://www.courdescomptes.ma",
    iconName: "Briefcase",
    imageUrl: "/images/logos/courdescomptes.png",
    internal: false
  },
  {
    id: "link-15",
    title: { ar: "وثيقة (Watiqa.ma)", fr: "Watiqa.ma", zgh: "Watiqa.ma" },
    desc: { ar: "منصة طلب مستخرجات أو نسخ كاملة من عقود الازدياد.", fr: "Plateforme de demande des extraits ou copies intégrale d'actes de naissance.", zgh: "Plateforme de demande des extraits ou copies intégrale d'actes de naissance." },
    url: "https://www.watiqa.ma",
    iconName: "FileText",
    imageUrl: "/images/logos/watiqa.png",
    internal: false
  },
  {
    id: "link-16",
    title: { ar: "الحالة المدنية (Alhalalmadania.ma)", fr: "Alhalalmadania.ma", zgh: "Alhalalmadania.ma" },
    desc: { ar: "البوابة الوطنية للحالة المدنية.", fr: "Portail de l'état civil.", zgh: "Portail de l'état civil." },
    url: "https://www.alhalalmadania.ma",
    iconName: "Users",
    imageUrl: "/images/logos/logo Maroc MI.png",
    internal: false
  },
  {
    id: "link-17",
    title: { ar: "رخص (Rokhas.ma)", fr: "Rokhas.ma", zgh: "Rokhas.ma" },
    desc: { ar: "منصة طلبات رخص التعمير والرخص الاقتصادية.", fr: "Plateforme des demandes d’autorisation d’urbanisme et autorisations économiques.", zgh: "Plateforme des demandes d’autorisation d’urbanisme et autorisations économiques." },
    url: "https://www.rokhas.ma",
    iconName: "Building2",
    imageUrl: "/images/logos/rokhas.png",
    internal: false
  },
  {
    id: "link-18",
    title: { ar: "مواكبة المستثمرين (CRI-Invest)", fr: "CRI-Invest", zgh: "CRI-Invest" },
    desc: { ar: "منصة مواكبة المستثمرين.", fr: "Plateforme d'accompagnement des investisseurs.", zgh: "Plateforme d'accompagnement des investisseurs." },
    url: "https://cri-invest.ma",
    iconName: "Briefcase",
    imageUrl: "/images/logos/cri invest logo.png",
    internal: false
  }
];

import { create } from "zustand";
import { getApiUrl } from "@/utils/apiConfig";

const API_URL = getApiUrl();

interface TransparenceState {
  links: TransparenceLink[];
  isLoading: boolean;
  isSeeding: boolean;
  fetchLinks: () => Promise<void>;
  addLink: (link: Omit<TransparenceLink, "id">) => Promise<void>;
  updateLink: (id: string, item: Partial<TransparenceLink>) => Promise<void>;
  deleteLink: (id: string) => Promise<void>;
}

export const useTransparenceStore = create<TransparenceState>((set, get) => ({
  links: initialTransparenceLinks, // Start with defaults
  isLoading: false,
  isSeeding: false,

  fetchLinks: async () => {
    set({ isLoading: true });
    try {
      const res = await fetch(`${API_URL}/transparence.php`);
      if (res.ok) {
        const data = await res.json();
        if (data && Array.isArray(data)) {
          if (data.length === 0 && !get().isSeeding) {
            // Seeding if database is completely empty
            set({ isSeeding: true });
            const token = localStorage.getItem('kaynin_auth_token');
            // Check if admin to seed
            if (token) {
              await fetch(`${API_URL}/transparence.php`, {
                method: "POST",
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ bulk: true, links: initialTransparenceLinks })
              });
              set({ links: initialTransparenceLinks, isSeeding: false, isLoading: false });
            } else {
               // Normal user, just keep defaults in memory if DB empty
               set({ isSeeding: false, isLoading: false });
            }
          } else if (data.length > 0) {
            set({ links: data });
          }
        }
      }
    } catch (error) {
      console.error("Failed to fetch transparence links", error);
    } finally {
      set({ isLoading: false });
    }
  },

  addLink: async (item) => {
    const newItem = { ...item, id: `link-${Date.now()}` };
    const token = localStorage.getItem('kaynin_auth_token');
    if (!token) return;

    // Optimistic update
    set(state => ({ links: [...state.links, newItem] }));

    try {
      await fetch(`${API_URL}/transparence.php`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(newItem)
      });
    } catch (e) {
      console.error("Failed to add link", e);
      get().fetchLinks(); // Revert
    }
  },

  updateLink: async (id, item) => {
    const token = localStorage.getItem('kaynin_auth_token');
    if (!token) return;

    // Optimistic update
    set(state => ({
      links: state.links.map(l => l.id === id ? { ...l, ...item } : l)
    }));

    try {
      const current = get().links.find(l => l.id === id);
      if (current) {
        await fetch(`${API_URL}/transparence.php?id=${id}`, {
          method: "PUT",
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
          body: JSON.stringify(current)
        });
      }
    } catch (e) {
      console.error("Failed to update link", e);
      get().fetchLinks(); // Revert
    }
  },

  deleteLink: async (id) => {
    const token = localStorage.getItem('kaynin_auth_token');
    if (!token) return;

    // Optimistic update
    set(state => ({
      links: state.links.filter(l => l.id !== id)
    }));

    try {
      await fetch(`${API_URL}/transparence.php?id=${id}`, {
        method: "DELETE",
        headers: { 'Authorization': `Bearer ${token}` }
      });
    } catch (e) {
      console.error("Failed to delete link", e);
      get().fetchLinks(); // Revert
    }
  }
}));

// Backwards compatibility wrappers
export function loadTransparenceLinks() {
  return useTransparenceStore.getState().links;
}
export function saveTransparenceLinks() {
  console.warn("saveTransparenceLinks is deprecated with Zustand, use store methods.");
}
export function deleteTransparenceLink(id: string) {
  useTransparenceStore.getState().deleteLink(id);
}
export function updateTransparenceLink(id: string, item: Partial<TransparenceLink>) {
  useTransparenceStore.getState().updateLink(id, item);
}
export function addTransparenceLink(item: Omit<TransparenceLink, "id">) {
  useTransparenceStore.getState().addLink(item);
}
